import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { SUBSECTION_HEADLINE_CONVERTER_TOKEN, SubsectionHeadlineConverter } from './subsection-headline.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        subsectionHeadlineFeature: {
          module: () => import('./subsection-headline.module').then((m) => m.SubsectionHeadlineModule),
          cmsComponents: ['subsection_headline'],
        },
      }
    }),
    {
      provide: SUBSECTION_HEADLINE_CONVERTER_TOKEN,
      useExisting: SubsectionHeadlineConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        subsection_headline: SUBSECTION_HEADLINE_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class SubsectionHeadlineFeatureModule {}
